import React, { useEffect, useState } from "react";
import { Text, View } from "@react-pdf/renderer";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import QuestionResponse from "../../../exportacion_react_pdf/QuestionResponse";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";
import TableGroup from "../../../exportacion_react_pdf/TableGroup";
import obtenerCategoriasProductos from "../../../../services/visitas_tecnicas/getCategoriaProductosService";

// Define el documento
const ExportPaso8 = ({ formData, styles }) => {
  const [dataCategoriasxproducto, setDataCategoriasxproducto] = useState(
    formData?.productos || []
  );

  useEffect(() => {
    const cargarCategoriasYProductos = async () => {
      try {
        const response = await obtenerCategoriasProductos();

        if (response.success) {
          // Extraer categorías y productos en mapas para acceso rápido
          const categoriaMap = new Map(
            response.categorias.map((cat) => [cat.id, cat.nombre])
          );
          const productoMap = new Map(
            response.productos.map((prod) => [prod.id, prod.nombre])
          );

          // Verificar que `lista_productos_fortalecimiento_economico` sea un array antes de hacer `.map()`
          if (
            Array.isArray(formData?.lista_productos_fortalecimiento_economico)
          ) {
          
            const listaFormateada =
              formData.lista_productos_fortalecimiento_economico.map(
                (item) => ({
                  categoria: categoriaMap.get(item.categoria) || "Desconocido",
                  productos: Array.isArray(item.producto)
                    ? item.producto.map(
                      (id) => productoMap.get(id) || "Producto Desconocido"
                    )
                    : [],
                })
              );
            setDataCategoriasxproducto(listaFormateada);
          } else {
            setDataCategoriasxproducto([]); // Evita errores y deja la variable en un estado seguro
          }
        } else {
          console.error(
            "Error al cargar categorías y productos:",
            response.message
          );
        }
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    };

    cargarCategoriasYProductos();
  }, [formData]); // Se agrega formData como dependencia para que se actualice si cambia.

  return (
    <>
      {/* Sección de Identificació del proyecto */}
      <View style={styles.section}>
        <Text style={styles.title_1}>DISPONIBILIDAD FORMACIÓN</Text>

        <CheckboxGroup
          label="¿Ha recibido capacitación específica sobre igualdad de género?"
          selectedValue={
            formData?.recibio_capacitacion_temas_relacionados || ""
          }
        ></CheckboxGroup>

        {formData?.recibio_capacitacion_temas_relacionados === "Sí" && (
          <TextAreaLabel
            label={"¿En qué temas se ha capacitado?"}
            value={formData?.en_que_temas_capacitado || ""}
          ></TextAreaLabel>
        )}
        <TextAreaLabel
          label={"¿En que temas le gustaria capacitarse?"}
          value={formData?.en_que_temas_gustaria_capacitarse || ""}
        ></TextAreaLabel>

        <QuestionResponse
          label={
            "¿Cuál es su disponibildiad de tiempo para participar de de los procesos de formacion?"
          }
          value={
            formData?.disponibilidad_tiempo_participar_procesos_formacion || ""
          }
        ></QuestionResponse>

        <CheckboxGroup
          label="¿Con qué dispositivo cuenta?"
          selectedValue={formData?.dispositivos_cuenta || ""}
          options={["Celular", "Computador", "Tablet", "Ninguno"]}
        ></CheckboxGroup>

        <CheckboxGroup
          label="¿Tiene acceso a internet?"
          selectedValue={formData?.tiene_acceso_internet || ""}
        ></CheckboxGroup>

        <CheckboxGroup
          label="¿Se tomará registro fotográfico de la visita?"
          selectedValue={formData?.tomara_registro_fotografico || ""}
        ></CheckboxGroup>

        <QuestionResponse
          label={"¿Número de fotografias a registrar?"}
          value={formData?.numero_fotografias || ""}
        ></QuestionResponse>

        {/* Título secundario */}
        <Text style={styles.greyTag}>
          PROPUESTA PLAN DE FORTALECIMIENTO ECONÓMICO
        </Text>

        <Text style={styles.noteText}>
          El plan de foralrecimiento economico contempla la entrega de
          materiales, herramientas e insumos por un valor maximo de$3,000,000
          por productor. En esta primera visita se debe proponer de manera
          conjunta el plan de compras, para lo cual se indican algunos ejemplos.
          Los items propuestos deben estar directamente relacionados con el
          diagnostico, las necesidades y los indicadores propuestos.
          Posteriormente serán definidos en la segunda visita y evaluados por el
          comité del proyecto.
        </Text>

        <TableGroup
          questionTitle=""
          headers={["categoria", "productos"]}
          headerDescriptions={["Categoria", "Productos"]}
          data={dataCategoriasxproducto}
        />
      </View>
    </>
  );
};

export default ExportPaso8;
